import EmptyStateImage from 'assets/images/EmptyStateImage';
import If from 'shared/If';

import Typography from '@eduzz/houston-ui/Typography';

import { Container } from './styles';

interface IProps {
  title?: string;
  subtitle?: string | React.ReactNode;
  width?: string;
  height?: string;
}
export const EmptyState: React.FC<IProps> = ({ title, subtitle, height, width }) => {
  return (
    <Container>
      <If condition={title}>
        <Typography size='md' weight='semibold'>
          {title}
        </Typography>
      </If>
      <If condition={!!subtitle}>
        <Typography size='xs' weight='regular'>
          {subtitle}
        </Typography>
      </If>

      <EmptyStateImage height={height} width={width} />
    </Container>
  );
};
